import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { IDrawResultState } from './types';

export const drawResultRootSelector = (state: IState) => state.drawResultReducer;

export const drawResultCardsSelector = createSelector(
  drawResultRootSelector,
  (state: IDrawResultState) => state.cards,
);

export const drawResultPointsSelector = createSelector(
  drawResultRootSelector,
  (state: IDrawResultState) => state.points,
);
